import SidebarNavListItem from "./SidebarNavListItem";
import React from "react";

const SidebarNavList = ({ pages, depth }) => {
  return (
    <>
      {pages.map((page) => {
        // Render item and children
        return (
          <SidebarNavListItem
            key={page.title}
            depth={depth}
            href={page.href}
            icon={page.icon}
            badge={page.badge}
            badgeFeature={page.badgeFeature}
            title={page.title}
            childrenItems={page.children}
          />
        );
      })}
    </>
  );
};

export default SidebarNavList;
